import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';

import MenuContent from './SideMenuContent';

import { User } from '../types/Types'; // #POW-5
import { useContext, useState } from 'react';
import AuthContext from '../context/AuthContext';
import DialogUserProfile from './dialogs/DialogUserProfile'; // #POW-26
import { blue } from '@mui/material/colors'; // #POW-26
import { useTranslation } from "react-i18next"; // #POW-29

interface SideMenuMobileProps {
  open: boolean | undefined;
  toggleDrawer: (newOpen: boolean) => () => void;
  user: User; // #POW-5
}

export default function SideMenuMobile({ open, toggleDrawer, user }: SideMenuMobileProps) {
  const auth = useContext(AuthContext)
  const { t } = useTranslation();  // #POW-29
 
  const [openDialogUserProfile, setOpenDialogUserProfile] = useState(false); // #POW-26
  
  const handleLogoutClick = () => {
    auth.onLogout();
  };

  // #POW-26
  const handleClickOpenDialogUserProfile = () => {
    setOpenDialogUserProfile(true);
  };

  // #POW-26
  const handleCloseDialogUserProfile = () => {
    setOpenDialogUserProfile(false);
  };

  return (
    <>
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: 'none',
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Stack
        sx={{
          maxWidth: '70dvw',
          height: '100%',
        }}
      >
        <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1 }}>
          <Stack
            direction="column"
            sx={{ gap: 1, alignItems: 'flex-start', flexGrow: 1, p: 1 }}
          > {/* #POW-5 */}
            <Avatar sx={{ bgcolor: blue[900], cursor: 'pointer' }} onClick={handleClickOpenDialogUserProfile}>{user?.avatar}</Avatar> {/* #POW-26 */}
            <Typography component="p" variant="h6"> {/* #POW-5 */}
              {user?.fullName}
            </Typography>
            <Typography variant="caption" component="p"> {/* #POW-5 */}
              {user?.jobTitle}
            </Typography>
          </Stack>
          {/*<MenuButton showBadge>
            <NotificationsRoundedIcon />
          </MenuButton>*/}
        </Stack>
        <Divider />
        <Stack sx={{ flexGrow: 1 }}>
          <MenuContent role={user?.entitlement ?? ''}/> {/* #POW-20 */}
          <Divider />
        </Stack>
        
        <Stack sx={{ p: 2 }}>
          <Button variant="outlined" fullWidth startIcon={<LogoutRoundedIcon />}  onClick={handleLogoutClick}>
            {t('menu.logout')}
          </Button>
        </Stack>
      </Stack>
    </Drawer>
    <DialogUserProfile open={openDialogUserProfile} onClose={handleCloseDialogUserProfile} user={user} /> {/* #POW-26 */}
    </>
  );
}
